<template>
  <div class="flex-col">
    <div class="w-full mt-2 panel">
      <div class="flex flex-row w-full text-blue font-bold">{{ $t('detailed_report_date') }}</div>
      <p class="text-gray-400 text-sm mb-2">{{ $t('detailed_report_date_help') }}</p>

      <div class="flex space-x-2">
        <div class="w-1/3">
          <b-field>
            <b-numberinput
              v-model="week"
              :placeholder="$t('week_of_the_year')"
              controls-position="compact"
              max="52"
              min="1"
              expanded
              icon-pack="fas"
              @keypress.native="onlyNumber"
            />
          </b-field>
          <!-- <input
          v-model="week" class="input"
          type="number" :placeholder="$t('week_of_the_year')"> -->
        </div>

        <div class="w-1/3">
          <b-datepicker
            :placeholder="$t('select_period')"
            v-model="weeklyRangeForm"
            :first-day-of-week="parseInt($t('first_day_of_week'))"
            :month-names="$t('months_names')"
            :day-names="$t('days_names')"
            icon-pack="fas"
            range
            >
          </b-datepicker>
        </div>
      </div>
    </div>

    <SelectSectionReportPanel v-if="report_sections.length > 1"
      :sections="report_sections"
      @epc-select-sections="(sections) => { report_sections = sections }"
    />

    <b-tabs v-if="report_sections.length" v-model="mainActiveTab" type="is-boxed">
      <!-- report sections -->
      <b-tab-item v-for="(tab, index) in report_sections" :key="'report_section_'+index" :visible="tab.print">

        <template slot="header">
          <b-icon pack="fas" icon="tasks"></b-icon>
          <span> {{ tab.name }} </span>
        </template>

        <div>
          <div class="w-full mt-4 panel">

            <div v-if="tab.progress_scheduled != undefined && tab.progress_scheduled != null" class="w-full mb-3">
              <div class="flex flex-row w-full text-blue font-bold">{{ $t('progress_scheduled_plant_photovoltaic') }}</div>
              <div class="flex flex-row w-3/3 border border-gray-300 rounded-lg p-2 bg-white shadow-md mt-3">
                <div v-for="progress in tab.progress_scheduled" class="w-2/5 my-2">
                  <div class="inline-block w-4/5">
                    <b-field :label="$t(progress.name)">
                      <b-input v-model="progress.value" type="is-primary"></b-input>
                    </b-field>
                  </div>
                </div>
              </div>
            </div>

            <!-- Enlace directo al Gantt -->
            <div v-if="tab.code === 'GANTT'" class="mb-3">
              <a href="/project/activities/gantt" target="_blank" class="button is-link is-outlined">
                <b-icon pack="fas" icon="external-link-alt"></b-icon>
                <span>{{ $t('open_gantt') }}</span>
              </a>
            </div>

            <div class="flex flex-row w-full text-blue font-bold">{{ $t('images') }}</div>
            <div class="w-full">

              <view-select-resource
                :visible="tab.with_drawing || tab.with_activity_document"
                :image="tab.with_drawing ? tab.drawing_image : tab.with_activity_document ? tab.activity_image : null"
                :type-resource="tab.with_drawing ? 'drawing' : 'activity'"
                :is-url="true"
                @epc-delete-resource="(type) => { deleteImage(tab.id, null, type) }"
                @epc-show-select-resource-modal="(type) => { openModalActivityImage(index, null, type) }"
              />

              <!-- Orientación del Gantt: solo si la config permite al usuario cambiarla.
                   Si no, se oculta y se usa la orientación definida en la config. -->
              <div v-if="tab.code === 'GANTT' && tab.gantt_user_can_change_orientation"
                class="flex justify-between items-center w-full mt-2 mb-2">
                <span class="mr-4">{{ $t('gantt_page_orientation') }}</span>
                <b-select v-model="tab.gantt_landscape" size="is-small">
                  <option :value="false">{{ $t('portrait') }}</option>
                  <option :value="true">{{ $t('landscape') }}</option>
                </b-select>
              </div>

              <!-- color picker and input text for status_oc name and color -->
              <!-- En la sección GANTT esta lista actúa como "leyenda general": se aplica
                   a todas las imágenes que no definan leyendas específicas propias. -->
              <legend-document-panel v-if="tab.with_status"
                :legends="tab.status_oc"
                :title="tab.code === 'GANTT' ? $t('general_legend') : null"
                :subtitle="tab.code === 'GANTT' ? $t('general_legend_hint') : null"
                @epc-add-legend="(legend) => { tab.status_oc.push(legend) }"
                @epc-delete-legend="(index) => { tab.status_oc.splice(index, 1) }"
              />

              <!-- image viewer from tab.images-->
              <div v-for="(image, imgindex) in tab.images" :key="'image_'+imgindex" class="w-full">
                <view-select-resource
                  :visible="tab.images.length > 0"
                  :image="image"
                  :type-resource="'image'"
                  :is-url="false"
                  :is-gantt="tab.code === 'GANTT'"
                  :named-resource="true"
                  :indexResource="imgindex + 1"
                  @epc-delete-resource="(type) => { deleteImage(tab.id, imgindex, type) }"
                  @epc-upload-resource="(type) => { uploadImage(tab.id, imgindex, tab.code == 'GANTT') }"
                  @epc-show-select-resource-modal="(type) => { openModalActivityImage(index, imgindex, type) }"
                  @epc-select-gantt-capture="(image) => { handleGanttCapture(tab.id, imgindex, image) }"
                />

                <!-- Leyendas específicas por imagen (solo Gantt con leyendas habilitadas):
                     apagado hereda la leyenda general; encendido usa solo su propia lista -->
                <div v-if="tab.code === 'GANTT' && tab.with_status && tab.images.length > 0"
                  class="w-full mt-1 mb-2"
                  style="margin-left: 1rem; padding-left: 1rem; border-left: 3px solid #dbdbdb;">
                  <div class="flex flex-row items-center">
                    <b-switch v-model="image.custom_legends" size="is-small" type="is-primary">
                      {{ $t('custom_legends_for_image', { number: imgindex + 1 }) }}
                    </b-switch>
                    <span v-if="!image.custom_legends" class="text-gray-400 text-sm ml-2">{{ $t('uses_general_legend') }}</span>
                  </div>
                  <legend-document-panel v-if="image.custom_legends"
                    :legends="image.legends"
                    :subtitle="$t('custom_legends_hint')"
                    @epc-add-legend="(legend) => { image.legends.push(legend) }"
                    @epc-delete-legend="(legendIndex) => { image.legends.splice(legendIndex, 1) }"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>

      </b-tab-item>
    </b-tabs>

    <div class="w-full text-center">
      <b-button type="is-success" color="green" @click="exportReport" :loading="isLoadingExport" :tooltip="txtTooltipExport">
        <b-icon pack="fas" icon="file-export"></b-icon> <span>{{ $t('generate_report') }}</span>
      </b-button>
      <b-button type="is-primary" color="blue" @click="exportExcelCurrentProgress" :loading="isLoadingExportExcel" :tooltip="txtTooltipExport">
        <b-icon pack="fas" icon="file-export"></b-icon> <span>{{ $t('generate_only_excel') }}</span>
      </b-button>
    </div>

    <!-- modal with input image for upload Images -->
    <UploadResourceModal ref="refUploadResourceModal"
      @load:image_section="handleLoadResource"
    />

    <select-image-from-activity-modal ref="refSelectResourceFromActivityModal"
      :activities="activities"
      :drawings="drawings"
      :report_sections="JSON.parse(JSON.stringify(report_sections))"
      @epc-select-success="handleSelectResourceFromActivity"/>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import moment from 'moment'

  import SelectSectionReportPanel from './components/select-sections-report-panel.vue'
  import ViewSelectResource from './components/view-select-resource.vue'
  import SelectImageFromActivityModal from './components/select-image-from-activity-modal.vue'
  import UploadResourceModal from './components/load-resource-modal.vue'
  import LegendDocumentPanel from './components/legend-document-panel.vue'

  import { getConfigDetailedReport } from './services/detailed-report.service.js'


  export default {
    components: {
      SelectSectionReportPanel,
      ViewSelectResource,
      SelectImageFromActivityModal,
      UploadResourceModal,
      LegendDocumentPanel
    },

    props: {
      typeReport: { type: String, default: null },
    },

    data: () => ({
      s3bucket: window.config.s3bucket,
      isLoading: true,

      weeklyRangeForm: [],
      weeklyRange: [], // rango de fechas procesado
      week: null, // semana enviado para el pdf

      status_oc:[], // { name: 'status name', color: 'color',}

      report_sections: [],

      showModal: false,
      UploadId: null,
      uploadImageIdx: null,
      dropFileTemp: null,
      uploadImageName: null,

      mainActiveTab: 0,

      isLoadingExport: false,
      isLoadingExportExcel: false,
      txtTooltipExport: null,
      activities: [],
      drawings: [],
      showModalActivityImage: false,
      showModalDrawingImage: false,
      activityImage: {
        tabIndex: 0,
        imageIndex: 0,
        url: '',
        activity_id: null,
        subactivity_id: null,
        document_id: null,
        subactivities: [],
        documents: [],
        type: 'image'
      },
    }),

    computed: {
      selectedCompanyAlias: function() {
        return this.company ? this.company.alias : null
      },
      ...mapGetters({
        project: 'app/project',
        user: 'auth/user',
        company: 'app/company',
        dashboardReport: 'app/dashboardReport',
      }),
    },

    created() {
      this.loadConfigDetailedReport()
    },

    mounted() {
      if (this.project == null) {
        this.$router.push('/projects');
      } else {

        let pageInfo = {
          title: this.project.name,
          subtitle: this.$t('project_home_page_subtitle'),
          menuOption: '2-1',
        }

        this.$store.dispatch('app/updatePageInfo', {info: pageInfo})

        this.getActivities()
        this.getDrawings()
      }

    },

    methods: {
      onlyNumber (event) {
        const charCode = event.which ? event.which : event.keyCode
        if (charCode < 48 || charCode > 57) {
          event.preventDefault()
        }
      },

      handleSelectResourceFromActivity(obj) {
        this.report_sections = obj;
      },

      handleLoadResource(resource) {
        const images = this.report_sections.find(tab => tab.id == resource.tabId).images
        images.splice(resource.loadImageIdx, 1, this.mergeImageKeepingLegends(images[resource.loadImageIdx], resource.image))
        this.$refs.refUploadResourceModal.hide();
      },

      // Al reemplazar una imagen (upload / captura del gantt) el objeto se sustituye
      // entero: conservamos details y las leyendas específicas ya definidas por el usuario.
      mergeImageKeepingLegends(prev, image) {
        prev = prev || {}
        return {
          details: prev.details || '',
          custom_legends: prev.custom_legends || false,
          legends: prev.legends || [],
          ...image
        }
      },

      async getSubactivities(activityId){
        const { data } = await axios.get("/api/v2/activity/" + activityId + "/subactivities");
        return data.subactivities;
      },

      async getActivities(){
        const { data } = await axios.get("/api/v2/activities", {'params' : { p : this.project.id, per_page: 999}});
        this.activities = data.activities;
      },

      async getDocuments(activityId){
        const { data } = await axios.get("/api/v2/activity/" + activityId + "/documents");
        return data.documents.filter(doc => doc.type == 1 || (doc.type == 0 && doc.mime_type == 'application/pdf'));
      },

      async getDrawings(){
        let params = {
          text: '',
          with: 'drawings'
        };

        const { data } = await axios.get(
          "/api/v2/project/" + this.project.id + "/documents",
          { params: params }
        );

        if (data && data.success) {
          this.drawings = data.documents;
        }
      },

      // MODAL ACTIVITY DOCUMENTS FUNCTIONS
      async openModalActivityImage(tabIndex, imageIndex, type = 'image', modal = 'activity') {
        this.activityImage = {
          tabIndex,
          imageIndex,
          url: '',
          activity_id: null,
          subactivity_id: null,
          document_id: null,
          subactivities: [],
          documents: [],
          type
        }

        // if (modal == 'drawing') {
        //   console.log('openModalActivityImage', this.activityImage);
        //   this.showModalDrawingImage = true
        // } else {
          // this.showModalActivityImage = true
          this.$refs.refSelectResourceFromActivityModal.show(this.activityImage);
        // }
      },

      uploadImage(tabId, imgIndex, isGantt = false) {
        this.$refs.refUploadResourceModal.show({tabId, imgIndex, isGantt});
      },

      handleGanttCapture(tabId, imgIndex, image) {
        const images = this.report_sections.find(tab => tab.id == tabId).images
        images.splice(imgIndex, 1, this.mergeImageKeepingLegends(images[imgIndex], image));
      },

      deleteImage(tabId, imageIndex, type = 'image') {
        if (type == 'drawing') {
          this.report_sections.find(tab => tab.id == tabId).drawing_image = '';
        } else if (type == 'activity') {
          this.report_sections.find(tab => tab.id == tabId).activity_image = '';
        } else {
          const images = this.report_sections.find(tab => tab.id == tabId).images
          images.splice(imageIndex, 1, this.mergeImageKeepingLegends(images[imageIndex], {id: imageIndex + 1, name: this.$t('image_number', { number: imageIndex + 1 }), image: null}))
        }
      },

      async exportExcelCurrentProgress(){
        if ( !this.isLoadingExportExcel ) {
          this.txtTooltipExport = this.$t('generating');

          this.$notify.success('generating_report');
          this.isLoadingExportExcel = true;
          let self = this
          let url = '/api/v2/project/' + this.project.id + '/dashboard/excel_report_current_progress';


          await axios.post(url, {infoTabs: [{infotab:"excel"}]} )
            .then(response => {
              self.$notify.success('generating_report')
              self.isLoadingExportExcel = false;
              self.txtTooltipExport = this.$t('export')
            })
            .catch((error) => {

              self.$notify.error(error.error_msg || 'error_retrieving_data')
              self.isLoadingExportExcel = false
              self.txtTooltipExport = this.$t('export')
            });

        }

      },

      async exportReport() {

        if ( !this.isLoadingExport ) {

          // El rango de semana es obligatorio: define el corte de fecha del informe.
          // Si no está seleccionado, avisamos y abortamos (evita el error en backend).
          if (!Array.isArray(this.weeklyRangeForm) || this.weeklyRangeForm.length < 2
              || !this.weeklyRangeForm[0] || !this.weeklyRangeForm[1]) {
            this.$buefy.toast.open({
              message: this.$t('select_week_range_required'),
              type: 'is-warning',
              position: 'is-top-right',
            });
            return;
          }

          this.txtTooltipExport = this.$t('generating');

          // guardamos configuración
          await this.saveConfigToCache()

          this.weeklyRange = this.weeklyRangeForm ? this.weeklyRangeForm.map(date => {
            return moment(date).format('DD-MM-YYYY')
          }) : []
          // console.log(this.report_sections[1].weeklyRange)

          this.$notify.success('generating_report');
          this.isLoadingExport = true;
          let self = this
          let url = '/api/v2/project/' + this.project.id + '/dashboard/dashboardreport';

          let infoTabs = []

          for (let reportSection of this.report_sections) {
            let reportImages = []
            if (reportSection.print) {
              for (let i = 0; i < reportSection.images.length; i++) {
                let img = reportSection.images[i]
                if (img.image) {
                  if (img.is_activity_document) {
                      reportImages.push({
                        name: img.name, key: '', image: img.image,
                        custom_legends: !!img.custom_legends, legends: img.legends || []
                      })
                  } else {

                    let code = reportSection.code + '_image_' +i+ '_image_' + img.name

                    // let form = new FormData();
                    // form.append('file', img.image)
                    // form.append('key', code)

                    // no vale, POST superiores a 1MB pueden fallar (413 Entity Too Large)
                    // let {data} = await axios.post('/api/v2/s3/upload-temp?optimize=1', form)

                    let data = await this.storeImage(img.image, {})
                    // la url que devuelve aws esta dando problemas "SignatureDoesNotMatch". Usamos ruta directa a la imagen
                    data.urlManual = 'https://'+window.config.s3bucket+'/'+data.key

                    if (data) {
                      reportImages.push({
                        name: img.name, key: data.uuid, image: data.urlManual, details: img.details || '',
                        custom_legends: !!img.custom_legends, legends: img.legends || []
                      })
                    }
                  }

                }
              }
            }
            infoTabs.push({...reportSection, images: reportImages, subactivities: [], documents: []})
          }

          // await axios.post(url, datapost)

          await axios.post(url, {infoTabs, weeklyRange: this.weeklyRange, week: this.week} )
            .then(response => {
              self.$notify.success('generating_report')
              this.$emit('refresh-history')
              self.isLoadingExport = false;
              self.txtTooltipExport = this.$t('export')
            })
            .catch((error) => {
              //Se produjo un error

              self.$notify.error(error.error_msg || 'error_retrieving_data')
              self.isLoadingExport = false
              self.txtTooltipExport = this.$t('export')
            });
        }
      },

      // CUSTOM VAPOR STORE METHOD
      async storeImage(file, options = null) {

        // esto ya sube automaticamente a la ruta /tmp del bucket del entorno (epc-tracker-storage / *-local / *-dev)
        const response = await axios.post('/vapor/signed-storage-url', {
            'visibility': 'public-read',
            'bucket': options.bucket || '',
            'content_type': options.contentType || file.type,
            'expires': options.expires || ''
        });

        if (typeof options.progress === 'undefined') {
            options.progress = () => {};
        }

        // This is the fix for the headers. Instance just for the S3 PUT
        var instance = axios.create();
        instance.defaults.headers.common = {};
        const s3Response = await instance.put(response.data.url, file, {
            headers: response.data.headers,
            onUploadProgress: (progressEvent) => {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            }
        });

        response.data.extension = file.name.split('.').pop()

        return response.data;

      },

      async saveConfigToCache() {
        let config = this.report_sections.map(tab => {
          let tabData = {
            print: tab.print
          }
          if (tab.activity_image) {
            tabData.activity_image = tab.activity_image
          }
          if (tab.drawing_image) {
            tabData.drawing_image = tab.drawing_image
          }
          if (tab.status_oc) {
            tabData.status_oc = tab.status_oc
          }
          return tabData
        })

        this.$store.dispatch('app/setDashboardReport', {dashboardReport: { report_sections: config} })
      },

      async loadConfigFromCache() {
        if (this.dashboardReport.report_sections) {
          for (let i = 0; i < this.dashboardReport.report_sections.length; i++) {
            if (this.report_sections[i]) {
              let config = this.dashboardReport.report_sections[i]
              Object.assign(this.report_sections[i], config)
            }
          }
        }
      },

      async loadConfigDetailedReport() {
        let cfg = [];

        if (this.project?.config?.activity_groups?.reports?.detailed) {
          cfg = this.project.config.activity_groups.reports.detailed;
        } else {
          try {
            cfg = await getConfigDetailedReport(this.project.id);
           } catch (e) {
             this.$buefy.toast.open({ message: this.$t('error_loading_data'), type: 'is-danger' })
           }
        }

        this.report_sections = cfg;
        this.loadConfigFromCache();
      },

      LoadReport(report) {
        this.week = report.week;

        const fechasFormateadas = report.weeklyRange.map(date => {
            let splitDate = date.split('-')
            return new Date(splitDate[2], splitDate[1] - 1, splitDate[0])
          })

        this.weeklyRangeForm = fechasFormateadas;
        for (const section of this.report_sections) {
          let section_report = Object.values(report.infoTabs)
            .find(s => {
              if (! s.code) {
                return s.name.toLowerCase() === section.name.toLowerCase()
              } else {
                return s.code.toLowerCase() === section.code.toLowerCase()
              }
            })

          section.print = section_report.print
          section.with_activity_document = section_report.with_activity_document
          section.with_drawing = section_report.with_drawing

          if (section.name.toLowerCase() === 'general') {
            for (let index = 0; index < section_report.images.length; index++) {
              const element = section_report.images[index];
              section.images[index].image = element.image
              section.images[index].name = element.name
              section.images[index].is_activity_document = true

            }
          }

          else if (section.code === 'OC') {
            if(section_report.with_activity_document) {
              section.activity_image = section_report.activity_image
            } else {
              section.drawing_image = section_report.drawing_image
            }

            // Restauramos las entradas de leyenda; `with_status` (capacidad definida en
            // la config: userCanDefineLegend) NO se degrada al cargar un informe ya
            // generado: si la config habilita leyendas, el panel debe seguir visible.
            this.$set(section, 'status_oc', Array.isArray(section_report.status_oc) ? section_report.status_oc : [])
            this.$set(section, 'with_status', section.with_status || section_report.with_status)

            for (let index = 0; index < section_report.images.length; index++) {
              const element = section_report.images[index];
              if (! element.image.includes('amazonaws.com/tmp')) {
                section.images[index].image = element.image
                section.images[index].name = element.name
                section.images[index].is_activity_document = true
              }
            }
          }

          else if (section.code === 'LEV') {
            section.activity_image = null
            section.drawing_image = null

            if(section_report.with_activity_document) {
              section.activity_image = section_report.activity_image
            } else if (section_report.with_drawing) {
              section.drawing_image = section_report.drawing_image
            }

            // section.activity_image = section_report.activity_image

            for (let index = 0; index < section_report.images.length; index++) {
              const element = section_report.images[index];
              if (! element.image.includes('amazonaws.com/tmp')) {
                section.images[index].image = element.image
                section.images[index].name = element.name
                section.images[index].is_activity_document = true
              }

            }
          }

          else if (section.code === 'ME') {
            section.drawing_image = section_report.drawing_image

            // Restauramos las entradas de leyenda; `with_status` (capacidad definida en
            // la config: userCanDefineLegend) NO se degrada al cargar un informe ya
            // generado: si la config habilita leyendas, el panel debe seguir visible.
            this.$set(section, 'status_oc', Array.isArray(section_report.status_oc) ? section_report.status_oc : [])
            this.$set(section, 'with_status', section.with_status || section_report.with_status)

            for (let index = 0; index < section_report.images.length; index++) {
              const element = section_report.images[index];
              if (! element.image.includes('amazonaws.com/tmp')) {
                section.images[index].image = element.image
                section.images[index].name = element.name
                section.images[index].is_activity_document = true
              }

            }
          }

          else if (section.code === 'MM') {
            section.drawing_image = section_report.drawing_image
            for (let index = 0; index < section_report.images.length; index++) {
              const element = section_report.images[index];

              if (! element.image.includes('amazonaws.com/tmp')) {
                section.images[index].image = element.image
                section.images[index].name = element.name
                section.images[index].is_activity_document = true
              }
            }
          }

          else if (section.code === 'SET') {
            if(section_report.with_activity_document) {
              section.activity_image = section_report.activity_image
            } else {
              section.drawing_image = section_report.drawing_image
            }

            // Restauramos las entradas de leyenda; `with_status` (capacidad definida en
            // la config: userCanDefineLegend) NO se degrada al cargar un informe ya
            // generado: si la config habilita leyendas, el panel debe seguir visible.
            this.$set(section, 'status_oc', Array.isArray(section_report.status_oc) ? section_report.status_oc : [])
            this.$set(section, 'with_status', section.with_status || section_report.with_status)

            for (let index = 0; index < section_report.images.length; index++) {
              const element = section_report.images[index];

              if (! element.image.includes('amazonaws.com/tmp')) {
                section.images[index].image = element.image
                section.images[index].name = element.name
                section.images[index].is_activity_document = true
              }
            }
          }

          else if (section.code === 'BESS') {
            if(section_report.with_activity_document) {
              section.activity_image = section_report.activity_image
            } else {
              section.drawing_image = section_report.drawing_image
            }

            // Restauramos las entradas de leyenda; `with_status` (capacidad definida en
            // la config: userCanDefineLegend) NO se degrada al cargar un informe ya
            // generado: si la config habilita leyendas, el panel debe seguir visible.
            this.$set(section, 'status_oc', Array.isArray(section_report.status_oc) ? section_report.status_oc : [])
            this.$set(section, 'with_status', section.with_status || section_report.with_status)

            for (let index = 0; index < section_report.images.length; index++) {
              const element = section_report.images[index];

              if (! element.image.includes('amazonaws.com/tmp')) {
                section.images[index].image = element.image
                section.images[index].name = element.name
                section.images[index].is_activity_document = true
              }
            }
          }

          else {
            section.activity_image = section_report.activity_image
            section.drawing_image = section_report.drawing_image
            // Restauramos las entradas de leyenda; `with_status` (capacidad definida en
            // la config: userCanDefineLegend) NO se degrada al cargar un informe ya
            // generado: si la config habilita leyendas, el panel debe seguir visible.
            this.$set(section, 'status_oc', Array.isArray(section_report.status_oc) ? section_report.status_oc : [])
            this.$set(section, 'with_status', section.with_status || section_report.with_status)

            // GANTT: la capacidad (gantt_user_can_change_orientation) viene de la config y no se
            // degrada. Solo si está activa restauramos la orientación que el usuario eligió en el
            // informe guardado; si no, se mantiene la de config.
            if (section.code === 'GANTT' && section.gantt_user_can_change_orientation) {
              this.$set(section, 'gantt_landscape', section_report.gantt_landscape ?? section.gantt_landscape)
            }

            for (let index = 0; index < section_report.images.length; index++) {
              const element = section_report.images[index];

              if (! element.image.includes('amazonaws.com/tmp')) {
                section.images[index].image = element.image
                section.images[index].name = element.name
                section.images[index].details = element.details || ''
                section.images[index].is_activity_document = true
                // Restauramos las leyendas específicas por imagen (Gantt)
                this.$set(section.images[index], 'custom_legends', !!element.custom_legends)
                this.$set(section.images[index], 'legends', Array.isArray(element.legends) ? element.legends : [])
              }
            }
          }


        }
      },

    },

  };
</script>
